import { appFaultModel } from "@/core/modules/appFault/models/AppFaultModel";
import { CloudHelpers } from "@/core/modules/helpers/CloudHelpers";

export const isVatCodeUnique = async (vatCode: string, brokerId = "empty"): Promise<boolean> => {
  try {
    if (vatCode === undefined) return false;

    return CloudHelpers.runValidatorFunction("featuresBrokerVatCodeValidator", vatCode, brokerId);
  } catch (error: unknown) {
    appFaultModel.catchAppError("BrokerModel.isVatCodeUnique", { vatCode, brokerId }, error);
    return false;
  }
};
